import { Component, Inject } from '@angular/core';
import { NzModalRef, NZ_MODAL_DATA, NzModalService } from 'ng-zorro-antd/modal';
import { PinModalComponent } from '../pin-modal/pin-modal.component';
import { DataserviceService } from 'src/app/dataservice.service';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-mdu-list',
  templateUrl: './mdu-list.component.html',
  styleUrl: './mdu-list.component.css'
})
export class MduListComponent {

  constructor(
    @Inject(NZ_MODAL_DATA) public modal: any,
    private data: DataserviceService,
    private modalCtrl: NzModalService,
    private message: NzMessageService
  ) {}

  ngOnInit() { }

  handlePinClick(pin: any, index: any) {
    const id = this.message.loading('Getting pin data..', { nzDuration: 0 }).messageId;
    this.data.getData(`pins/pin-data/${pin?.id}/${this.modal.provider}/${this.modal.company}`)
      .subscribe({
        next: async (res: any) => {
          res.id = pin?.id
    
          const modal = this.modalCtrl.create({
            nzContent: PinModalComponent,
            nzClosable: false,
            nzMaskClosable: false,
            nzFooter: null,
            nzData: {
              data: res,
              coords: {
                latitude: pin?.latitude,
                longitude: pin?.longitude,
              },
              dispositions: this.modal.dispositions,
              provider: this.modal.provider,
              company: this.modal.company
            }
          })

          setTimeout(() => {
            this.message.remove(id)
          }, 1000)

          modal.afterClose
            .subscribe((res: any) => {
              if (res?.pin) {
                const newId = this.message.loading('Updating pin data..', { nzDuration: 0 }).messageId;
                this.modal.data[index].color = res?.pin;

                setTimeout(() => {
                  this.message.remove(newId)
                }, 250)
              }
            })
        }
      });
    
  }

  async addMdu() {

      const modal = await this.modalCtrl.create({
        nzContent: PinModalComponent,
        nzClosable: false,
        nzMaskClosable: false,
        nzFooter: null,
          nzData: {
            data: null,
            address: this.modal.data?.[0].address_line_1 + ' ' + this.modal.data?.[0].address_city + ', ' + this.modal.data?.[0].address_state + ' ' + this.modal.data?.[0].address_zip,
            coords: {
              latitude: this.modal?.data?.[0].latitude,
              longitude: this.modal?.data?.[0].longitude,
            },
            dispositions: this.modal.dispositions,
            area: this.modal?.data?.[0]?.areaId || null,
            provider: this.modal.provider,
            company: this.modal.company,
            mdu: true
          }
      });

      modal.afterClose
        .subscribe((res: any) => {
          if(res) {
            this.data.getData(`pins/mdu-pins?id=${this.modal.data?.[0]?.id}&provider=${this.modal.provider}`)
              .subscribe({
                next: (res: any) => {
                  this.modal.data = res?.data
                }
              })
          }
        })
  }
}
